import React, { useState, useEffect } from "react";
import { Box, Container, makeStyles, Typography } from "@material-ui/core";
import Page from "src/components/Page";
import Form from "./Form";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import {
  apiEndpoints,
  apiPostRequest,
  apiPutRequest,
  apiGetRequest,
  apiGetByIdRequest,
} from "src/utils/api/api";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import { kmMessages } from "src/constant/Messages";
import KmPageTitle from "src/components/layout/KmPageTitle"
import { useMountedState } from "react-use";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  title: {
    marginLeft: theme.spacing(3),
  },
}));

const VotingManagementForm = ({
  setLogoutUser,
  enableGlobalLoader,
  disableGlobalLoader,
  displaySnackbar,
  ...rest
}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { entryId } = useParams();
  const [voting, setVoting] = useState();
  const editMode = rest.kmaction === "edit";
  const [votingStartDate, setVotingStartDate] = useState(null);
  const [votingEndDate, setVotingEndDate] = useState(null);
  const [answerOptions, setAnswerOptions] = useState(null);
  const [workingGroups, setWorkingGroups] = useState(null);
  const [formReady, setFormReady] = useState(false);

  let pageTitle =
    rest.kmaction === "new" ? "Nowe głosowanie" : "Edycja głosowania";

    const isMounted = useMountedState();

  useEffect(() => {
    enableGlobalLoader();
    apiGetRequest(apiEndpoints.getAnswerOption.path, true)
      .then((data) => {
        disableGlobalLoader();
        if (isMounted){
          setAnswerOptions(data);

        apiGetRequest(apiEndpoints.getWorkingGroups.path, true)
          .then((data) => {
            disableGlobalLoader();
            setWorkingGroups(data);
            if (editMode) {
              enableGlobalLoader();
              apiGetByIdRequest(
                apiEndpoints.getVotingDetails.path,
                entryId,
                true
              )
                .then((data) => {
                  disableGlobalLoader();
                  
                  setVoting(data);

                  setFormReady(true);
                })
                .catch((error) => {
                  disableGlobalLoader();
                });
            } else {
              setFormReady(true);
            }
          })
          .catch((error) => {
            disableGlobalLoader();
          });
        }
      })
      .catch((error) => {
        disableGlobalLoader();
      });
    return () => {};
  }, []);

  const onSubmit = (
    values,
    optionsSelected,
    documentStructNodeId,
    documentNotApplicable,
    startStopNotif,
    generalVoting,
    selectedDocumentStructNodeIds
  ) => {

    enableGlobalLoader();

    if (editMode) {
      apiPutRequest(
        apiEndpoints.updateVoting.path,
        {
          id: entryId,
          title: values.title,
          startsAt: votingStartDate
            ? votingStartDate.format("YYYY-MM-DDTHH:mm:ss")
            : null,
          endsAt: votingEndDate
            ? votingEndDate.format("YYYY-MM-DDTHH:mm:ss")
            : null,
          answerOptions: optionsSelected.map(
            (optionSelected) => optionSelected.id
          ),
          documentStructNodeId: documentStructNodeId,
          documentNotApplicable: documentNotApplicable,
          startStopNotifications: startStopNotif,
          general: generalVoting,
          votesExists: voting.votesExists,
          workingGroupId: (values.wgroup) ? values.wgroup.id : null,
          selectedDocumentStructNodeIds: selectedDocumentStructNodeIds
        },
        true
      )
        .then((data) => {
          disableGlobalLoader();
          navigate("/zarzadzanieglosowania/wprzygotowaniu");
        })
        .catch((error) => {
          disableGlobalLoader();
          if (error.response && error.response.status === 401) {
            setLogoutUser();
          } else if (error.response.status === 400 && error.response.data) {
            if (error.response.data.code === "VOTING_END_DATE_TO_OLD") {
              displaySnackbar({
                isOpen: true,
                severity: "error",
                autoHideDuration: 8000,
                message: kmMessages.error.voting.voteoption_dateendtoold,
              });
            } else if (
              error.response.data.code === "VOTING_START_DATE_TO_OLD"
            ) {
              displaySnackbar({
                isOpen: true,
                severity: "error",
                autoHideDuration: 8000,
                message: kmMessages.error.voting.voteoption_datestarttoold,
              });
            } else if (
              error.response.data.code === "VOTING_START_DATE_OLDER_THAN_END"
            ) {
              displaySnackbar({
                isOpen: true,
                severity: "error",
                autoHideDuration: 8000,
                message:
                  kmMessages.error.voting.voteoption_dateendolderthanstart,
              });
            }
          }
        });
    } else {
      apiPostRequest(
        apiEndpoints.addVoting.path,
        {
          title: values.title,
          startsAt: votingStartDate
            ? votingStartDate.format("YYYY-MM-DDTHH:mm:ss")
            : null,
          endsAt: votingEndDate
            ? votingEndDate.format("YYYY-MM-DDTHH:mm:ss")
            : null,
          answerOptions: optionsSelected.map(
            (optionSelected) => optionSelected.id
          ),
          documentStructNodeId: documentStructNodeId,
          documentNotApplicable: documentNotApplicable,
          startStopNotifications: startStopNotif,
          general: generalVoting,
          workingGroupId: (values.wgroup) ? values.wgroup.id : null,
          selectedDocumentStructNodeIds: selectedDocumentStructNodeIds
        },
        true
      )
        .then((data) => {
          disableGlobalLoader();
          navigate("/zarzadzanieglosowania/wprzygotowaniu");
        })
        .catch((error) => {
          disableGlobalLoader();
          if (error.response && error.response.status === 401) {
            setLogoutUser();
          } else if (error.response.status === 400 && error.response.data) {
            if (error.response.data.code === "VOTING_END_DATE_TO_OLD") {
              displaySnackbar({
                isOpen: true,
                severity: "error",
                autoHideDuration: 8000,
                message: kmMessages.error.voting.voteoption_dateendtoold,
              });
            } else if (
              error.response.data.code === "VOTING_START_DATE_TO_OLD"
            ) {
              displaySnackbar({
                isOpen: true,
                severity: "error",
                autoHideDuration: 8000,
                message: kmMessages.error.voting.voteoption_datestarttoold,
              });
            } else if (
              error.response.data.code === "VOTING_START_DATE_OLDER_THAN_END"
            ) {
              displaySnackbar({
                isOpen: true,
                severity: "error",
                autoHideDuration: 8000,
                message:
                  kmMessages.error.voting.voteoption_dateendolderthanstart,
              });
            }
          }
        });
    }
  };

  return (
    <Page className={classes.root} title={pageTitle}>
      <KmPageTitle>
        {pageTitle}
      </KmPageTitle>

      <Container maxWidth={false}>
        <Box mt={3}>
          <Form
            formReady={formReady}
            answerOptions={answerOptions}
            setAnswerOptions={setAnswerOptions}
            workingGroups={workingGroups}
            onSubmit={onSubmit}
            voting={voting}
            votingStartDate={votingStartDate}
            setVotingStartDate={setVotingStartDate}
            votingEndDate={votingEndDate}
            setVotingEndDate={setVotingEndDate}
            editMode={editMode}
          />
        </Box>
      </Container>
    </Page>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setLogoutUser: () => dispatch(actions.setLogoutUser()),
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
  displaySnackbar: (snackBarParameters) =>
    dispatch(actions.displaySnackbar(snackBarParameters)),
});

export default connect(null, mapDispatchToProps)(VotingManagementForm);
